export default {
  // 获取用户时区+8  +8.5 +10.75 -5
  timeZone () {
    let timezone = new Date().getTimezoneOffset() / 60
    let zone = -timezone > 0 ? '+' + String(-timezone) : -timezone
    return zone
  },
  globetime () {
    let timezone = new Date().getTimezoneOffset() / 60
    let mins = (new Date().getTimezoneOffset() / 60 - parseInt(timezone)) * 60
    let zone = -timezone > 0 ? '+' + -parseInt(timezone) + ':' + (-mins > 0 ? -mins : '00') : -parseInt(timezone) + ':' + (-mins > 0 ? -mins : '00')
    return zone
  },
  getTimeZoneCity () {
    let timeZoneId = Intl.DateTimeFormat().resolvedOptions().timeZone; //'Asia/Shanghai'
    return timeZoneId
  },
  formatDate (time) {
    var date = new Date(time.replace(/-/g, '/'))
    return date
  },
  numFormat (num) {
    let price = Number(num)
      .toFixed(2)
      .toString()
      .replace(/(\d{1,3})(?=(\d{3})+(?:$|\.))/g, '$1,')
    return price
  },
  setDate (date) {
    var date = new Date(date)
    return (date.getMonth() + 1) + '/' + date.getDate() + '/' + date.getFullYear()
  },
  setDateToWeek (date) {
    var date = new Date(date), week
    if (date.getDay() == 0) week = 'Sunday'
    if (date.getDay() == 1) week = 'Monday'
    if (date.getDay() == 2) week = 'Tuesday'
    if (date.getDay() == 3) week = 'Wednesday'
    if (date.getDay() == 4) week = 'Friday'
    if (date.getDay() == 5) week = 'Friday'
    if (date.getDay() == 6) week = 'Saturday'
    return week
  },
  setWeek (num) {
    switch (num) {
      case '7':
        return 'Sunday'
        break
      case '6':
        return 'Saturday'
        break
      case '5':
        return 'Friday'
        break
      case '4':
        return 'Thursday'
        break
      case '3':
        return 'Wednesday'
        break
      case '2':
        return 'Tuesday'
        break
      case '1':
        return 'Monday'
        break
      default:
        return ''
    }
  },
  toAppStore () {
    window.location.href = 'https://apps.apple.com/cn/app/id1573232431'
  },
  toGooglePlay () {
    window.location.href = 'http://www.pgyer.com/jtIz'
  },
  setCookies (obj, limitTime) {

    for (let i in obj) {
      document.cookie = i + '=' + obj[i]
    }
  },
  getCookie (name) {
    var arr = document.cookie.match(new RegExp('(^| )' + name + '=([^;]*)(;|$)'))
    if (arr != null) {
      return unescape(arr[2])
    } else {
      return null
    }
  },
  clearCookie (name) {
    let json = {}
    json[name] = ''
    this.setCookies(json, -1)
  },
  GetQueryString(name) {
    // 方法1：使用现代浏览器支持的URLSearchParams API（推荐）
    try {
      // 创建URL查询参数对象
      const urlParams = new URLSearchParams(window.location.search);

      // 检查参数是否存在
      if (urlParams.has(name)) {
        // 返回解码后的参数值（自动处理URL编码和+号空格）
        return decodeURIComponent(urlParams.get(name));
      }
    } catch (e) {
      // 如果URLSearchParams不可用，则回退到正则表达式方法
      console.warn("URLSearchParams not supported, falling back to regex");
    }

    return null;
  },
  getCustomColor(index){
    if(index==1)return'#999999'
    if(index==2)return'#B50604'
    if(index==3)return'#69A635'
  },
  getBgColor(index){
    if(index==1)return'#EEEEEE'
    if(index==2)return'#B5060433'
    if(index==3)return'#69A63533'
  },
  getStatusText(index){
    if(index==1)return 'videoClass.status.notStarted'
    if(index==2)return 'videoClass.status.inProgress'
    if(index==3)return 'videoClass.status.completed'
  },
  getHomeworkColor(index){
    if(index==1)return['#B50604','rgba(181, 6, 4, 0.2)','homework.status.notSubmitted']
    if(index==2)return['#3B82F6','rgba(59, 130, 246, 0.2)','homework.status.submitted']
    if(index==4)return['#69A635','rgba(105, 166, 53, 0.2)','homework.status.reviewed']
    if(index==5)return['#B50604','rgba(181, 6, 4, 0.2)','homework.status.draft']
    if(index==7)return['#999999','rgba(156, 163, 175, 0.2)','homework.status.ended']
  },
  getScore(n){
    if(n==1)return 'homework.score.fail'
    if(n==2)return 'homework.score.fair'
    if(n==3)return 'homework.score.medium'
    if(n==4)return 'homework.score.good'
    if(n==5)return 'homework.score.excellent'
  }
}



// WEBPACK FOOTER //
// ./src/utils/utils.js